import { openBlock as o, createElementBlock as n, mergeProps as t, createElementVNode as e } from "vue";
import { _ as d } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const C = {};
function i(l, r) {
  return o(), n("svg", t(l.$attrs, {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }), r[0] || (r[0] = [
    e("g", { id: "Play Circle Outline" }, [
      e("g", { id: "Icon" }, [
        e("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M21.53 16.848C21.8224 16.6653 22 16.3448 22 16C22 15.6552 21.8224 15.3347 21.53 15.152L13.53 10.152C13.2217 9.95933 12.8332 9.94913 12.5152 10.1254C12.1973 10.3016 12 10.6365 12 11L12 21C12 21.3635 12.1973 21.6984 12.5152 21.8746C12.8332 22.0509 13.2217 22.0407 13.53 21.848L21.53 16.848ZM14 19.1958V12.8042L19.1132 16L14 19.1958Z"
        }),
        e("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16Z"
        })
      ])
    ], -1)
  ]), 16);
}
const s = /* @__PURE__ */ d(C, [["render", i]]);
export {
  s as default
};
